module.exports = "<span class=\"inventory-icon\">\n  <span class=\"inventory-type-icon\">\n    <i class=\"fa fa-ticket\" ng-show=\"type === 'COVER'\"></i>\n    <i class=\"fa fa-ticket\" ng-show=\"type === 'TICKET'\"></i>\n    <i class=\"fa fa-glass\" ng-show=\"type === 'TABLE'\"></i>\n    <i class=\"fa fa-cubes\" ng-show=\"type === 'PACKAGE'\"></i>\n  </span>\n  <i class=\"fa fa-plus\" ng-show=\"type === 'UNKNOWN'\"></i>\n</span>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/inventoryIcon/template.html
// module id = 853
// module chunks = 1